import { Box, TextField, Typography } from '@mui/material'

import indexHooks from './hooks/index'
import { CommonModuleProps, QuestionItemProps } from './types.d'

const { referralSourceHooks } = indexHooks

const ReferralSource = ({ currentIndex }: CommonModuleProps) => {
  const { selectedReferralSource, onReferralSourceChange, currentData, isOtherSelected, otherReferralSource, onOtherReferralSourceChange } =
    referralSourceHooks(currentIndex)

  return (
    <div>
      <Box className="w-full !px-5 !py-4">
        <Typography className="!font-Averta6 !text-lg">
          {currentIndex + 1}. {currentData?.title}
        </Typography>
        {currentData?.desc && <Typography className="!font-Averta4 !text-sm !text-[#6B7280] !mt-1">{currentData?.desc}</Typography>}
      </Box>
      <Box className="w-full !px-5 !py-4">
        <div className="w-full grid gap-y-4">
          {currentData?.question?.referralSource?.map((item: QuestionItemProps) => {
            const active = item.key === selectedReferralSource
            return (
              <div key={item.key}>
                <Box
                  onClick={() => onReferralSourceChange(item.key)}
                  className={`${
                    active ? '!border-[#050A22]' : '!border-[#E0E2EF]'
                  } flex items-center cursor-pointer justify-start border rounded-xl px-4 py-2.5`}
                >
                  <Box className={`w-4 h-4 border rounded-2xl mr-4 ${active ? 'border-[#E74F4F] border-[6px]' : 'border-[#E0E2EF] '}`} />
                  <Typography className="!font-Averta4 !text-sm !leading-6">{item.desc}</Typography>
                </Box>
                {item.key === 'Other' && isOtherSelected && (
                  <TextField
                    fullWidth
                    placeholder="Please specify"
                    value={otherReferralSource}
                    onChange={event => onOtherReferralSourceChange(event.target.value)}
                    variant="outlined"
                    size="small"
                    className="mt-3"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px',
                        '& fieldset': {
                          borderColor: '#e0e2ef',
                        },
                        '&:hover fieldset': {
                          borderColor: '#c1c7d0',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#050a22',
                          borderWidth: '1px',
                        },
                      },
                      '& .MuiOutlinedInput-input': {
                        padding: '12px 14px',
                      },
                    }}
                  />
                )}
              </div>
            )
          })}
        </div>
      </Box>
    </div>
  )
}

export default ReferralSource
